__turbopack_context__.v({
  "back": "Slider-module-scss-module__VETdAW__back",
  "controls": "Slider-module-scss-module__VETdAW__controls",
  "forward": "Slider-module-scss-module__VETdAW__forward",
  "slider": "Slider-module-scss-module__VETdAW__slider",
});
